import type { JSX, ReactNode } from "react";

import { cn } from "../lib/utils.js";
import { Card } from "./ui/card.js";

/** Compact metric card: uppercase label, big value, muted sub-line. The default
 *  surface for any "one number + caption" tile (dashboard, retirement, etc.).
 *  Pass `children` for extra content (a gauge, a control) below the value. */
export function StatCard({
  label,
  value,
  sub,
  children,
  className,
}: {
  label: ReactNode;
  value?: ReactNode;
  sub?: ReactNode;
  children?: ReactNode;
  className?: string;
}): JSX.Element {
  return (
    <Card className={cn("gap-1.5 p-5", className)}>
      <span className="text-muted-foreground text-xs font-medium tracking-wide uppercase">
        {label}
      </span>
      {value !== undefined && <span className="text-3xl leading-tight font-semibold">{value}</span>}
      {sub !== undefined && <span className="text-muted-foreground text-xs">{sub}</span>}
      {children}
    </Card>
  );
}
